import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const CardThree = (props) => {
  const { t } = useTranslation();
  const { title, subtitle, link, btnText = t("developer.button.learn-more") } = props;
  return (
    <>
      <div className="card-three">
        <div className="content-box">
          <div className="content">
            <a title={title} href={link} rel="noopener noreferrer" target="_blank" className="title">
              {title}
            </a>
            <div title={subtitle} className="subtitle">
              {subtitle}
            </div>
          </div>
          <div className="link">
            <a href={link} rel="noopener noreferrer" target="_blank">
              {btnText}
            </a>
            <span className="arrow">
              <i className="icon authing-icon authing-arrow-right-line"></i>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
